import { render, staticRenderFns } from "./hoistTabs.vue?vue&type=template&id=548e6103&scoped=true&"
import script from "./hoistTabs.vue?vue&type=script&lang=js&"
export * from "./hoistTabs.vue?vue&type=script&lang=js&"
import style0 from "./hoistTabs.vue?vue&type=style&index=0&id=548e6103&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548e6103",
  null
  
)

export default component.exports